import React from 'react';
import NewAppIFrame from 'components/NewAppIFrameViewer';

const BusinessIdeas = () => {
  return (
    <NewAppIFrame
      iFramePagePath={"analytics/business-ideas"}
      title="Business Ideas"
    />
  );
};
export default BusinessIdeas;